import React from 'react';
import { AssistChip } from '@upsales/components';
import { useTranslation } from 'Components/Helpers/translate';

export type NotetakerStatusValue = { state: string; reason?: string };

export const NOTETAKER_STATUS_VISUAL: Record<
	string,
	{ type: 'success' | 'info' | 'danger' | 'alert' | 'neutral'; icon: string }
> = {
	will_join: { type: 'success', icon: 'microphone' },
	joining: { type: 'info', icon: 'microphone' },
	recording: { type: 'danger', icon: 'microphone' },
	completed: { type: 'success', icon: 'check' },
	failed: { type: 'alert', icon: 'microphone-slash' },
	wont_join: { type: 'neutral', icon: 'microphone-slash' }
};

const KNOWN_STATES: ReadonlySet<string> = new Set(Object.keys(NOTETAKER_STATUS_VISUAL));

export default function NotetakerStatusChip({ status }: { status?: NotetakerStatusValue }) {
	const { t } = useTranslation();

	// Unknown states render nothing, not a raw lang key. Set, not property lookup:
	// 'constructor' etc. pass a plain [key] check (WEB-9014).
	if (!status?.state || !KNOWN_STATES.has(status.state)) {
		return null;
	}

	const visual = NOTETAKER_STATUS_VISUAL[status.state];
	const title = t(`appointment.notetakerStatus.${status.state}`);

	return <AssistChip type={visual.type} icon={visual.icon as any} title={title} />;
}
